export * from './roof-type-1';
export * from './roof-type-2';
export * from './roof-type-3';
export * from './roof-type-4';
export * from './roof-type-5';
export * from './roof-type-6';
export * from './roof-type-7';
export * from './roof-type-8';
export * from './roof-type-9';
export * from './navigation-button';


import { NavigationButtonComponent } from './navigation-button';
import { RoofType1Component } from './roof-type-1';
import { RoofType2Component } from './roof-type-2';
import { RoofType3Component } from './roof-type-3';
import { RoofType4Component } from './roof-type-4';
import { RoofType5Component } from './roof-type-5';
import { RoofType6Component } from './roof-type-6';
import { RoofType7Component } from './roof-type-7';
import { RoofType8Component } from './roof-type-8';
import { RoofType9Component } from './roof-type-9';

export const BuildingMolecules = [
    RoofType1Component,
    RoofType2Component,
    RoofType3Component,
    RoofType4Component,
    RoofType5Component,
    RoofType6Component,
    RoofType7Component,
    RoofType8Component,
    RoofType9Component,
    NavigationButtonComponent,
];